.body {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-6);
  margin: 0 auto;
  max-width: 1600px;
  padding: var(--pgm-sys-spacing-10) var(--pgm-sys-spacing-6) var(--pgm-sys-spacing-16);
  width: 100%;
}

.search {
  background-color: var(--pgm-sys-color-surface-container-low);
  border-radius: 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-6);
  padding: var(--pgm-sys-spacing-6) var(--pgm-sys-spacing-8);
}

.header {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-1);
}

.title {
  color: var(--pgm-sys-color-on-surface);
  margin: 0;
}

.subtitle {
  color: var(--pgm-sys-color-on-surface-variant);
  margin: 0;
}

.inputRow {
  align-items: center;
  display: grid;
  gap: var(--pgm-sys-spacing-6);
  grid-template-columns: minmax(0, 0.75fr) minmax(0, 1fr);
}

.submit {
  justify-self: start;
}

.message {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-6);
  padding: var(--pgm-sys-spacing-10) 0;
}

.messageIcon {
  color: var(--pgm-sys-color-outline);
  font-size: 64px;
  font-variation-settings:
    "FILL" 0,
    "wght" 500,
    "GRAD" 0,
    "opsz" 48;
  line-height: 64px;
}

.messageText {
  color: var(--pgm-sys-color-on-surface-variant);
  margin: 0;
  text-align: center;
  white-space: pre-line;
}

.document {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-1);
}

.documentHeader {
  align-items: flex-start;
  display: flex;
  gap: var(--pgm-sys-spacing-6);
  justify-content: space-between;
}

.documentData {
  display: flex;
  flex-wrap: wrap;
  gap: var(--pgm-sys-spacing-10);
}

.field {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: var(--pgm-sys-spacing-2);
  min-width: 0;
}

.fieldLabel {
  color: var(--pgm-sys-color-on-surface);
}

.fieldValue {
  color: var(--pgm-sys-color-on-surface-variant);
  overflow-wrap: anywhere;
}

.download {
  flex-shrink: 0;
}

.signatures {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-4);
}

.divider {
  background-color: var(--pgm-sys-color-outline-variant);
  border: 0;
  height: 1px;
  margin: 0;
}

.signaturesTitle {
  color: var(--pgm-sys-color-on-surface);
  margin: 0;
}

.signaturesGrid {
  align-items: start;
  display: grid;
  gap: var(--pgm-sys-spacing-4);
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

@media (max-width: 1024px) {
  .inputRow {
    grid-template-columns: minmax(0, 1fr);
  }

  .signaturesGrid {
    grid-template-columns: minmax(0, 1fr);
  }
}

@media (max-width: 599.98px) {
  .body {
    padding: var(--pgm-sys-spacing-6) var(--pgm-sys-spacing-4) var(--pgm-sys-spacing-12);
  }

  .search {
    padding: var(--pgm-sys-spacing-4);
  }

  .documentHeader {
    flex-direction: column;
  }
}
